import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './WorkOrderFormModal.css';

const ACTION_CONFIG = {
  impossible: {
    title: '진행 불가 사유 입력',
    badge: '진행불가',
    color: '#ef4444',
    placeholder: '진행이 불가한 사유를 입력하세요.',
    submitText: '진행 불가',
    btnClass: 'btn-danger'
  },
  stop: {
    title: '업무 중단 사유 입력',
    badge: '업무중단',
    color: '#f59e0b',
    placeholder: '업무 중단 사유를 입력하세요.',
    submitText: '업무 중단',
    btnClass: 'btn-warning text-dark'
  },
  force_done: {
    title: '강제 완료 사유 입력',
    badge: '강제완료',
    color: '#10b981',
    placeholder: '강제 완료 사유를 입력하세요.',
    submitText: '강제 완료',
    btnClass: 'btn-success'
  },
  cancel: {
    title: '업무협조 취소 사유 입력',
    badge: '요청취소',
    color: '#ea580c',
    placeholder: '업무협조 요청을 취소하는 사유를 입력하세요.',
    submitText: '요청 취소',
    btnClass: 'btn-danger'
  },
  reject: {
    title: '처리결과 보완요청 사유 입력',
    badge: '보완요청',
    color: '#ef4444',
    placeholder: '보완이 필요한 사유를 입력하세요.',
    submitText: '보완요청',
    btnClass: 'btn-danger'
  },
  approve: {
    title: '처리결과 확인완료 처리',
    badge: '확인완료',
    color: '#10b981',
    placeholder: '확인 의견을 남겨주세요 (예: 수고 많으셨습니다. 처리결과 확인완료했습니다.)',
    submitText: '확인완료',
    btnClass: 'btn-success'
  }
};

const formatDateTime = (dateStr) => {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch {
    return dateStr;
  }
};

function WorkOrderOpinionModal({
  open = true,
  mode = 'input', // 'input' | 'view'
  actionType = 'reject', // 'impossible' | 'stop' | 'force_done' | 'reject' | 'approve'
  opinions = [], // view 모드일 때 조회할 사유 배열
  title = '',
  zIndex = 10050,
  onClose,
  onSubmit
}) {
  const [opinionText, setOpinionText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const config = ACTION_CONFIG[actionType] || ACTION_CONFIG.reject;
  const modalTitle = title || (mode === 'view' ? '사유 및 의견 확인' : config.title);

  const handleSubmit = async () => {
    if (actionType !== 'approve' && !opinionText.trim()) {
      alert('사유를 입력해 주세요.');
      return;
    }
    if (onSubmit) {
      try {
        setSubmitting(true);
        await onSubmit(opinionText.trim());
      } finally {
        setSubmitting(false);
      }
    }
  };

  const sortedOpinions = [...(opinions || [])].sort((a, b) => {
    const timeA = new Date(a.created_at || 0).getTime();
    const timeB = new Date(b.created_at || 0).getTime();
    return timeB - timeA; // 최신순 (내림차순)
  });

  const modalContent = (
    <div
      className="wo-modal-overlay"
      style={{ zIndex, backgroundColor: 'rgba(0, 0, 0, 0.65)' }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="wo-modal-dialog" style={{ maxWidth: '510px', width: '90%' }}>
        <div className="wo-modal-content" style={{ height: 'auto', minHeight: 'auto', maxHeight: '90vh' }}>

          {/* ── 헤더 ── */}
          <div
            className="wo-modal-header"
            style={{
              background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
              padding: '14px 20px'
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <span
                className="badge px-2 py-1"
                style={{ backgroundColor: config.color, color: '#fff', fontSize: '0.72rem' }}
              >
                {config.badge}
              </span>
              <h5 className="m-0 fw-bold fs-6 text-white">{modalTitle}</h5>
            </div>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              style={{ boxShadow: 'none' }}
            />
          </div>

          {/* ── 본문 ── */}
          <div className="p-3">
            {mode === 'view' ? (
              /* [조회 모드]: 등록된 사유 목록 카드 리스트 (최신순 정렬 + 뱃지 표출) */
              <div>
                {sortedOpinions && sortedOpinions.length > 0 ? (
                  <div className="d-flex flex-column gap-3" style={{ maxHeight: '420px', overflowY: 'auto' }}>
                    {sortedOpinions.map((op, idx) => {
                      const cfg = ACTION_CONFIG[op.action_type] || (op.action_type === 'approve' ? ACTION_CONFIG.approve : config);
                      const authorName = op.author?.name || op.user_name || op.author_name || '작성자';
                      const position = op.author?.org?.position || '';
                      const deptName = op.author?.org?.dept_name || '';

                      return (
                        <div
                          key={op.id || idx}
                          className="border rounded-2 bg-light"
                          style={{ borderLeft: `3px solid ${cfg.color}`, padding: '8px' }}
                        >
                          <div
                            className="d-flex align-items-center justify-content-between px-1 mb-1.5"
                            style={{ minHeight: '28px' }}
                          >
                            <div className="d-flex align-items-center gap-1.5" style={{ fontSize: '0.78rem' }}>
                              <span
                                className="badge px-1.5 py-0.5"
                                style={{ backgroundColor: cfg.color, color: '#fff', fontSize: '0.68rem', borderRadius: '4px', marginRight: '6px' }}
                              >
                                {cfg.badge}
                              </span>
                              <i className="fas fa-user-circle text-primary me-1" style={{ fontSize: '0.9rem' }} />
                              <span className="fw-semibold text-dark">
                                {authorName}
                              </span>
                              {position && <span className="text-secondary">{position}</span>}
                              {deptName && <span className="text-muted">({deptName})</span>}
                            </div>
                            <div className="d-flex align-items-center gap-1 text-muted" style={{ fontSize: '0.78rem' }}>
                              <i className="far fa-clock" style={{ fontSize: '0.75rem' }} />
                              <span>{formatDateTime(op.created_at)}</span>
                            </div>
                          </div>

                          <div
                            className="bg-white rounded border text-dark fw-normal"
                            style={{
                              fontSize: '0.82rem',
                              fontWeight: 'normal',
                              lineHeight: '1.5',
                              padding: '6px 8px',
                              whiteSpace: 'pre-wrap',
                              wordBreak: 'break-word',
                              minHeight: '130px',
                              maxHeight: '130px',
                              overflowY: 'auto'
                            }}
                          >
                            {op.opinion || '등록된 사유가 없습니다.'}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-4 text-muted small">
                    <i className="fas fa-inbox fs-3 mb-2 d-block text-secondary opacity-50" />
                    등록된 사유나 의견이 없습니다.
                  </div>
                )}
              </div>
            ) : (
              /* [입력 모드]: 사유 텍스트 입력 */
              <div>
                <div className="mb-1">
                  <label className="form-label fw-bold text-dark mb-1" style={{ fontSize: '0.85rem' }}>
                    사유 작성 <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control wo-opinion-textarea fw-normal"
                    rows={4}
                    style={{ fontSize: '0.82rem', fontWeight: 'normal', resize: 'vertical', minHeight: '130px', padding: '6px 8px' }}
                    placeholder={config.placeholder}
                    value={opinionText}
                    onChange={(e) => setOpinionText(e.target.value)}
                    autoFocus
                  />
                </div>
              </div>
            )}
          </div>

          {/* ── 푸터 ── */}
          <div className="wo-modal-footer" style={{ padding: '12px 20px', backgroundColor: '#f8fafc', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            {mode === 'view' ? (
              <button
                type="button"
                className="btn btn-secondary btn-sm px-4 fw-bold"
                onClick={onClose}
              >
                닫기
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm px-3"
                  onClick={onClose}
                  disabled={submitting}
                >
                  취소
                </button>
                <button
                  type="button"
                  className={`btn btn-sm px-3 fw-bold ${config.btnClass}`}
                  onClick={handleSubmit}
                  disabled={submitting}
                >
                  {submitting ? '처리 중...' : config.submitText}
                </button>
              </>
            )}
          </div>

        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}

export default WorkOrderOpinionModal;
